import socketIO from 'socket.io-client'

const socket = socketIO(`https://mschat.digitalk.com.br/`);

export default socket